import {
  formatDateOnlyStringFromLocalTime
} from './helpers';
import { modelPositions } from '../constants/employeePositions';
import emailTemplates from '../constants/emailTemplates';
import { MALE } from '../constants/general';

export const getPointOfContact = (bookingLocation, locationTypeId, locationContacts) => {
  if (bookingLocation.gender) {
    return bookingLocation.gender === MALE
        ? locationContacts[locationTypeId][0]
        : locationContacts[locationTypeId][1];
  }
  return locationContacts[locationTypeId];
}

export const getTemplateName = (positionName, pointOfContact, hasAgent) => {
  if (modelPositions.includes(positionName)) {
    return hasAgent ? emailTemplates.callSheetModelHmuAgency : emailTemplates.callSheetModelHmuNoAgency;
  }
  if (pointOfContact) {
    return hasAgent ? emailTemplates.callSheetGeneralAgency : emailTemplates.callSheetGeneralNoAgency;
  }
  return hasAgent ? emailTemplates.callSheetGeneralNoContactAgency : emailTemplates.callSheetGeneralNoContactNoAgency;
};

export const buildCallsheetsToSend = (
  employeesToSend,
  bookings,
  selectedDate,
  locationContacts,
  getCallSheet
) => {
  const callsheetsToSend = [];
  const noCallsheets = [];
  employeesToSend.forEach((employee) => {
    const {
      agents,
      bookingId,
      email,
      name,
      positionName,
      locationTypeId,
      locationName,
      arrivalTime,
    } = employee;
    const hasAgent = agents.length;
    const callsheet = getCallSheet(bookings, selectedDate, locationContacts, positionName);
    if (!callsheet) {
      noCallsheets.push({
        email: hasAgent ? agents.map(agent => agent.email).toString() : email,
        name,
        positionName,
        locationName,
      });
      return;
    }
    // Since there's both a contact point and contact point if unfilled, contactPoint shouldn't ever be null
    // but email templates require a value, so in the case that contactPoint is null, we need to define a default value.
    const pointOfContact = getPointOfContact(bookings[locationTypeId][locationName], locationTypeId, locationContacts);
    const templateName = getTemplateName(positionName, pointOfContact, hasAgent);
    const date = formatDateOnlyStringFromLocalTime(selectedDate);
    const headerOpt = '';
    if (hasAgent) {
      agents.forEach(agent => {
        callsheetsToSend.push({
          recipients: { main: [agent.email] },
          templateName,
          params: {
            headerOpt,
            date,
            callsheet,
            employeeName: name,
            pointOfContact,
            arrivalTime,
            agentName: `${agent.firstName} ${agent.lastName}`,
          },
          bookingId,
        });
      });
    } else {
      callsheetsToSend.push({
        recipients: { main: [email] },
        templateName,
        params: {
          headerOpt,
          date,
          callsheet,
          employeeName: name,
          pointOfContact,
          arrivalTime,
          agentName: null,
        },
        bookingId,
      });
    }
  });
  return { callsheetsToSend, noCallsheets };
}

// sorts numerical strings naturally (1, 2, 10 instead of 1, 10, 2)
export const naturalSortKeys = (a, b) =>
  a.key.localeCompare(b.key, undefined, { numeric: true, sensitivity: 'base' });
